export default __webpack_public_path__ + "static/media/NotoSans-Regular.d1821692.woff2";